<template>
    <ul class="pl-0" @contextmenu="selectComponentDEV($event, schema.model)">
        <li
          v-for="(form, index) in values"
          :key="index"
          class="position-relative"
        >
          <vue-form-generator
            tag="div"
            :schema="{ fields: schema.fields }"
            :model="values[index]"
          />
          <span v-if="!index == 0" :class="[schema.action.remove.styleClasses, 'cursor-pointer position-absolute top-0 right-0']" @click="handleRemove(index)">
            <v-icon class="mr-4">remove_circle_outline</v-icon>
            {{ schema.action.remove.label }}
          </span>
        </li>
        <br />
      <span :class="[schema.action.add.styleClasses, 'd-flex d-inline cursor-pointer']" @click="handleAdd">
        <v-icon class="mr-4">add_circle_outline</v-icon>
        {{ schema.action.add.label }}
      </span>
    </ul>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  data: () => ({
    valid: false,
    show: false,
    values: []
  }),

  props: {
    schema: { type: Object, default: () => ({}) },
    mode: { type: String, default: undefined },
    page: { type: String, default: null },
    tab: { type: Number, default: null },
    step: { type: Number, default: null }
  },

  mixins: [abstractField, devComponentMixin],

  mounted() {
    let arr = this.values
    if(arr.length === 0) {
      this.values = [{}]
    }
  },

  methods: {
    handleAdd() {
      this.values.push({})
    },

    handleRemove(value) {
      this.values.splice(value, 1)
    },

    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  },
  watch: {
    values() {
      let keyValue = ''

      const selectedItems = this.values
      this.$store.dispatch('page/updateSelectedItems', { selectedItems, keyValue });
    }
  }
}
</script>

<style lang="scss">
.field-i4proFormDynamic {
  width: 100%;
  max-width: 50%;
  display: flex;
}
ul {
  list-style: none;
  li {    
    background: rgba(0, 0, 0, 0.02);

    &:nth-of-type(odd) {
      background: white;
    }
  }
}
</style>